import React, { useEffect } from 'react'
import {useState,useMemo} from 'react'
import TabStrip from '../../../../organisms/Tabstrip';
import { _getComponent } from '../../../../organisms/Tabstrip/getComponent';
import { Box } from '@mui/material';
import Comments from '../../../../organisms/Comments';
import Form from "../Form"
import { getData } from '../../../../../services';
import { useCookies } from 'react-cookie';


const TaskViewModal = ({modalState, tableData ,  refetchData , onFormDirty , Projects , clientList , onClose , employeeList , departmentList ,refetchClientList,  rolesList,teamList , mytask,isAdmin}) => {
  const [cookies] = useCookies(['e_t'])
    const [activeTab, setActiveTab] = useState("Task Details");
    const [relatedUsers, setRelatedUsers] = useState([])


    const fetchUsers = async() => {
      const res = await getData({endpoint : 'Comment/getAllEmployeesToBeTagged', token : cookies.e_t, 
        params : {
        task_id : modalState?.modalId}
      })
        setRelatedUsers(res?.data)
    }

    useEffect(()=> {

      fetchUsers();
    },[])

    const onTabChange = (event, value) => {
      setActiveTab(value);
    };
  
    const data = useMemo(
      () => [
          {
              id: 1,
              label: "Task Details",
              view: <Form
              mytask={mytask}
              isAdmin={isAdmin}
              onFormDirty={onFormDirty}
              initialData={
                modalState.title === "Edit Task" ? modalState.modalData : null
              }
              refetchData={refetchData}
              Projects={Projects}
              clientList={clientList}
              onClose={onClose}
              employeeList={employeeList}
              departmentList={departmentList}
              rolesList={rolesList}
              teamList={teamList}
              refetchClientList={refetchClientList}
            />,
            },
            {
              id: 2,
              label: "Comments",
              view: <Comments tableData={modalState.modalData} relatedUsers={relatedUsers}/>,
            },
      ],
      [relatedUsers,Projects,clientList,employeeList,departmentList,rolesList,teamList,refetchClientList]
    );
  
    return (
      <>
         {/* <div className="">
              <div className="d-flex gap-3 mb-1">
                  <div>
                        <CustomButton
                            text="Filters"
                            type="btn-outline-dark"
                            icon={<Filter />}
                        />
                  </div>
                  <div>
                   <Search
                        placeholder="Search by task name"
                    // onSearchEmit={(item) => setSearchedValue(item)}
                    />
                  </div>
                    
                </div>
            </div> */}
          <TabStrip padding={"0 0 0 0"} activeTab={activeTab} onTabChange={onTabChange} data={data} />
          <Box sx={{ width: "100%" }}>
            <Box sx={{ p: '10px ' }}>{_getComponent(data,activeTab)}</Box>
          </Box>
  
      </>
    )
  }
  

export default TaskViewModal